import React from 'react'
import { Layout } from 'antd'
import './index.less'

const { Footer } = Layout

class CustomisedFooter extends React.Component {
  render() {
    return (
      <Footer className='app-footer'>
        {/* by @Maxbonus */}
      </Footer>
    )
  }
}

export default CustomisedFooter



// WEBPACK FOOTER //
// src/components/AppFooter/index.jsx